import { disableBodyScroll, enableBodyScroll, clearAllBodyScrollLocks, BodyScrollOptions } from 'body-scroll-lock';

var hamburger = {
    selector: {
		item: '.open-menu',
		toggle: '.submenu-toggle'
	},

    init: function() {
		var self = this;

        jQuery( document ).on('click', self.selector.item, function (e) {
            e.preventDefault();
            jQuery( 'body' ).toggleClass( 'menu-is-active' );
        });

        jQuery( document ).on('click', self.selector.toggle, function (e) {
			e.preventDefault();
			
            jQuery(this).closest('li').children('ul').toggleClass('active');
            jQuery(this).toggleClass('active');
        });
    }
}

export {
    hamburger
};